import { Toaster, toast } from "sonner";
import React, { Fragment, useState, useRef, useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import axios from "axios";
import axiosCacheAdapter from "axios-cache-adapter";
import "react-loading-skeleton/dist/skeleton.css";
import PrivateImage from '../PrivateImage/PrivateImage';
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";


const cache = axiosCacheAdapter.setupCache({
    maxAge: 5 * 60 * 1000,
});

const api = axios.create({
    adapter: cache.adapter,
});

var userEmail;
var JSToken;
var accessToken;
if (localStorage.user) {
    userEmail = localStorage.user_email;
    JSToken = JSON.parse(localStorage.user);
    accessToken = JSToken.access_token;
}

const config = {
    headers: { Authorization: `Bearer ${accessToken}` },
};

const ScholarshipApplications = () => {
    const [loadingSkeleton, setLoadingSkeleton] = useState(true);
    const [onFilters, setOnFilters] = useState(false);
    const [isNotFound, setIsNotFound] = useState(false);
    const [allScholarshipApplications, setAllScholarshipApplications] = useState(null);
    const [totalRegEntries, setTotalRegEntries] = useState();
    const [apiFilters, setApiFilters] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState();
    const [pageSize, setPageSize] = useState(10);
    const [pageNumbers, setPageNumbers] = useState([]);
    const tableRef = useRef(null);
    const navigate = useNavigate();


    const applyFilters = useFormik({
        initialValues: {
            email: "",
            scholarship_type: "",
            programme_type: "",
            application_status: ""
        },
        onSubmit: (values) => {
            setOnFilters(false);
            setLoadingSkeleton(true)
            setPageNumber(1);
            let apiFiltersSet = false;


            if (values.email) {
                if (values.email.length >= 1) {
                    // let email_filter = "%";
                    // for (let member in values.email) {
                    //     email_filter +=
                    //         values.email[member] + "%";
                    // }
                    setApiFilters(`["user","like","%${values.email}%"]`);
                    apiFiltersSet = true;
                }
            }
            if (values.scholarship_type) {
                if (values.scholarship_type.length >= 1) {
                    if (apiFiltersSet) {
                        setApiFilters((prevState) => [
                            prevState +
                            `,["scholarship_type","=","${values.scholarship_type}"]`,
                        ]);
                    } else {
                        setApiFilters(`["scholarship_type","=","${values.scholarship_type}"]`);
                    }
                    apiFiltersSet = true;

                }
            }
            if (values.programme_type) {
                if (values.programme_type.length >= 1) {
                    if (apiFiltersSet) {
                        setApiFilters((prevState) => [
                            prevState +
                            `,["programme_type","=","${values.programme_type}"]`,
                        ]);
                    } else {
                        setApiFilters(`["programme_type","=","${values.programme_type}"]`);
                    }
                    apiFiltersSet = true;

                }
            }
            if (values.application_status) {
                if (values.application_status.length >= 1) {
                    if (apiFiltersSet) {
                        setApiFilters((prevState) => [
                            prevState +
                            `,["application_status","=","${values.application_status}"]`,
                        ]);
                    } else {
                        setApiFilters(`["application_status","=","${values.application_status}"]`);
                    }
                    apiFiltersSet = true;

                }
            }
            if (!apiFiltersSet) {
                setApiFilters([])
            }
        }
    });

    const scroll = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    const scrollToTop = () => {
        tableRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleClick = (number) => {
        setPageNumber(number);
        scroll();
        scrollToTop();
    };

    const handlePaginationClick = (event) => {
        if (event == "Previous") {
            if (pageNumber > 1) {
                setPageNumber(pageNumber - 1);
                scroll();
                scrollToTop()
            }
        } else if (event == "Next") {
            if (pageNumber < totalPages) {
                setPageNumber(pageNumber + 1);
                scroll();
                scrollToTop()
            }
        }
    };

    useEffect(() => {
        const fetchAllApplications = async () => {
            try {
                setLoading(true);
                setIsLoading(true);
                let offset = (pageNumber - 1) * pageSize;
                await api.get(
                    `https://dash.bestdiplomats.org/api/method/paginated-scholarship-application-list?filters=[${apiFilters}]&limit_start=${offset}&limit_page_length=${pageSize}`,
                    config
                )
                    .then((response) => {
                        setTotalRegEntries(response.data.message.pagination.total);
                        setTotalPages(response.data.message.pagination.total_pages);
                        setPageNumbers([]);
                        for (
                            let i = 1;
                            i <= Math.ceil(response.data.message.pagination.total / pageSize);
                            i++
                        ) {
                            setPageNumbers((prevState) => [...prevState, i]);
                        }
                        setAllScholarshipApplications(response.data.message.data);
                        setLoadingSkeleton(false);
                        setIsNotFound(false);
                        setLoading(false);
                    });
                setIsLoading(false);
            } catch (e) {
                console.log(e);
                if (e?.code == "ERR_NETWORK" || e?.response?.status == 404) {
                    setTotalRegEntries(0);
                    setTotalPages(0);
                    setPageNumber(0);
                    setAllScholarshipApplications([]);
                    toast.error('No Data Found')
                    setIsNotFound(true)
                    setLoadingSkeleton(true)
                } else {
                    setLoadingSkeleton(false)
                    toast.error('No Data Found')
                    setIsNotFound(true)
                    setTotalRegEntries(0);
                    setTotalPages(0);
                    setPageNumber(0);
                }
            }
        };
        fetchAllApplications();
    }, [pageNumber, apiFilters]);

    return (
        <div>
            {     /* Header */}
            <div className="flex justify-end mt-3 gap-2">
                <Toaster position="bottom-left" richColors />
                {loadingSkeleton ? (
                    <>
                        <Skeleton width={80} height={40} />{" "}
                        <Skeleton width={80} height={40} />{" "}
                        <Skeleton width={80} height={40} />{" "}
                        <Skeleton width={80} height={40} />
                    </>
                ) : (
                    <>
                        {" "}
                        <button
                            onClick={() => {
                                setOnFilters(true);
                            }}
                            className="ml-1 inline-flex justify-center gap-1 rounded-md border border-transparent bg-blue-500 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                        >
                            <span>Filter</span>{" "}
                            <svg
                                className="w-5 h-5"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
                                ></path>
                            </svg>
                        </button>
                        <button
                            type="button"
                            onClick={() => {
                                
                                applyFilters.resetForm();
                                setApiFilters([]);
                            }}
                            className="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                        >
                            Clear Filter
                        </button>
                    </>
                )}
            </div>

            {    /* Drawer for Filters */}
            <Transition.Root show={onFilters} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setOnFilters}>
                    <div className="fixed inset-0" />

                    <div className="fixed inset-0 overflow-hidden">
                        <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                                <Transition.Child
                                    as={Fragment}
                                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                                    enterFrom="translate-x-full"
                                    enterTo="translate-x-0"
                                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                                    leaveFrom="translate-x-0"
                                    leaveTo="translate-x-full"
                                >
                                    <Dialog.Panel className="pointer-events-auto w-screen max-w-2xl">
                                        <form
                                            className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl"
                                            onSubmit={applyFilters.handleSubmit}
                                        >
                                            <div className="flex-1">
                                                {/* Header */}
                                                <div className="bg-gray-100 px-4 py-6 sm:px-6">
                                                    <div className="flex items-start justify-between space-x-3">
                                                        <div className="space-y-1">
                                                            <Dialog.Title className="text-lg flex gap-2 font-medium text-gray-900">
                                                                <span>Filters</span>{" "}
                                                                <svg
                                                                    className="w-6 h-6 mt-1"
                                                                    fill="none"
                                                                    stroke="currentColor"
                                                                    viewBox="0 0 24 24"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                        strokeWidth="2"
                                                                        d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
                                                                    ></path>
                                                                </svg>
                                                            </Dialog.Title>
                                                        </div>
                                                        <div className="flex h-7 items-center">
                                                            <button
                                                                type="button"
                                                                className="text-gray-400 hover:text-gray-500"
                                                                onClick={() => {
                                                                    setOnFilters(false);
                                                                }}
                                                            >
                                                                <span className="sr-only">Close panel</span>
                                                                <XMarkIcon
                                                                    className="h-6 w-6"
                                                                    aria-hidden="true"
                                                                />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Divider container */}

                                                <div className="space-y-6 py-6 sm:space-y-0 sm:divide-y sm:divide-gray-200 sm:py-0">
                                                    <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                                                        <label
                                                            htmlFor="email"
                                                            className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                                                        >
                                                            Email
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="email"
                                                            id="email"
                                                            onChange={applyFilters.handleChange}
                                                            value={applyFilters.values.email}
                                                            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                                        />
                                                    </div>
                                                    <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                                                        <label
                                                            htmlFor="scholarship_type"
                                                            className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                                                        >
                                                            Scholarship Type
                                                        </label>
                                                        <select
                                                            type="text"
                                                            name="scholarship_type"
                                                            id="scholarship_type"
                                                            onChange={applyFilters.handleChange}
                                                            value={applyFilters.values.scholarship_type}
                                                            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="Full Scholarship">
                                                                Full Scholarship
                                                            </option>
                                                            <option value="Partial Scholarship">
                                                                Partial Scholarship
                                                            </option>
                                                            <option value="Conference Scholarship">
                                                                Conference Scholarship
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                                                        <label
                                                            htmlFor="programme_type"
                                                            className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                                                        >
                                                            Programme Type
                                                        </label>
                                                        <select
                                                            type="text"
                                                            name="programme_type"
                                                            id="programme_type"
                                                            onChange={applyFilters.handleChange}
                                                            value={applyFilters.values.programme_type}
                                                            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="United Nations Immersion Programme">
                                                                United Nations Immersion Programme
                                                            </option>
                                                            <option value="Diplomatic Simulation">
                                                                Diplomatic Simulation
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                                                        <label
                                                            htmlFor="application_status"
                                                            className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                                                        >
                                                            Status
                                                        </label>
                                                        <select
                                                            name="application_status"
                                                            id="application_status"
                                                            onChange={applyFilters.handleChange}
                                                            value={applyFilters.values.application_status}
                                                            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="Payment Pending">Payment Pending</option>
                                                            <option value="Task Pending">Task Pending</option>
                                                            <option value="Task Submitted">Task Submitted</option>
                                                            <option value="Rejected">Rejected</option>
                                                            <option value="Approved">Approved</option>
                                                            <option value="Conference Selected">Conference Selected</option>
                                                            <option value="Completed">Completed</option>
                                                        </select>
                                                    </div>


                                                </div>
                                            </div>

                                            {/* Action buttons */}
                                            <div className="flex-shrink-0 border-t border-gray-200 px-4 py-5 sm:px-6">
                                                <div className="flex justify-end space-x-3">
                                                    <button
                                                        type="submit"
                                                        className="inline-flex color justify-center rounded-md border border-transparent bg-blue-500 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                                    >
                                                        Apply Filter
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            applyFilters.resetForm();
                                                            setLoadingSkeleton(true)
                                                            setApiFilters([]);
                                                        }}
                                                        className="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                                    >
                                                        Clear Filter
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                                        onClick={() => setOnFilters(false)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>

            {    /* Total Registrations Header */}
            <div className="mt-1 py-1 divide-y ">

                <p className="felx justify-end text-right font-semibold text-gray-600">
                    {loadingSkeleton ? (
                        <Skeleton width={40} height={20} />
                    ) : (
                        <>Registrations: {totalRegEntries} </>
                    )}
                </p>
            </div>

            { /* Main Table */}
            {isNotFound ? <div className="h-screen flex justify-center flex-col items-center ">
                <svg fill="none" className="w-40 h-40 text-gray-400" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 01-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0112 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                </svg> <span className=" text-lg text-gray-400">  No Data Found</span>
            </div> : <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"><table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-stone-100">
                    <tr>
                        <th
                            scope="col"
                            className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-800 sm:pl-6"
                        >
                            Applicant
                        </th>
                        <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-800"
                        >
                            Scholarship Type
                        </th>
                        <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-800"
                        >
                            Program Type
                        </th>
                        <th
                            scope="col"
                            className="px-3 py-3.5 whitespace-nowrap text-left text-sm font-semibold text-gray-800"
                        >
                            Status Registration
                        </th>

                        <th
                            scope="col"
                            className="relative py-3.5 pl-3 pr-4 sm:pr-6"
                        >
                            <span className="sr-only">View Application</span>
                        </th>
                    </tr>
                </thead>
                {loadingSkeleton ? (
                    <tbody className="divide-y divide-gray-200 bg-white">
                        <tr>
                            <td className="whitespace-nowrap py-3 pl-4  text-sm sm:pl-6">
                                <div className="flex items-center">
                                    <div
                                        className="h-14 w-14 flex-shrink-0"
                                    >
                                        <Skeleton borderRadius={40} width={50} height={50} />
                                    </div>
                                    <div className="ml-2">
                                        <div
                                            className="font-medium cursor-pointer text-gray-900"
                                        >
                                            <Skeleton width={90} height={10} />
                                        </div>
                                        <div className="text-gray-500">
                                            <Skeleton width={80} height={10} />
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                <Skeleton />
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                <div className="text-gray-900">
                                    <Skeleton />
                                </div>
                            </td>

                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                <div className="text-gray-900">
                                    <Skeleton />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                ) : (
                    <tbody className="divide-y divide-gray-200 bg-white">
                        {allScholarshipApplications?.map((person) => (
                            <tr key={person.name} onClick={() => {
                                navigate(`./${person.name}`, {
                                    state: { userData: { image: person.user?.user_image, name: person.user?.full_name, email: person.user?.email } }
                                });
                            }} className="cursor-pointer hover:bg-gray-50">
                                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6">
                                    <div className="flex items-center">
                                        <PrivateImage imageUrl={person.user?.user_image} className={"h-10 w-10 rounded-full cursor-pointer"} />
                                        <div className="ml-4">
                                            {person.user?.full_name}
                                            <div className="text-gray-500">
                                                {person.user?.email}
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                    <div className="text-gray-900">
                                        {person.scholarship_type?.split("(")[0].trim()}
                                    </div>
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                    <div className="text-gray-900">
                                        {person.programme_type}
                                    </div>
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                    {person.application_status == "Approved" ? (
                                        <span
                                            className="inline-flex rounded-full px-2 text-xs font-semibold leading-5"
                                            style={{
                                                backgroundColor: "#d1fae5", color: "#065f46", display: "flex",
                                                justifyContent: "center", padding: "0.25rem 0rem"
                                            }}
                                        >
                                            {person.application_status}
                                        </span>
                                    ) : person.application_status == "Rejected" ? (
                                        <span
                                            className="inline-flex rounded-full px-2 text-xs font-semibold leading-5"
                                            style={{
                                                backgroundColor: "#fee2e2", color: "#991b1b", display: "flex",
                                                justifyContent: "center", padding: "0.25rem 0rem"
                                            }}
                                        >
                                            {person.application_status}
                                        </span>
                                    ) : person.application_status == "Payment Pending" ? (
                                        <span
                                            className="inline-flex rounded-full px-2 text-xs font-semibold leading-5"
                                            style={{
                                                backgroundColor: "#fef3c7", color: "#92400e", display: "flex",
                                                justifyContent: "center", padding: "0.25rem 0rem"
                                            }}
                                        >
                                            {person.application_status}
                                        </span>
                                    ) : person.application_status == "Conference Selected" ? (
                                        <span
                                            className="inline-flex rounded-full px-2 text-xs font-semibold leading-5"
                                            style={{
                                                backgroundColor: "#dbeafe", color: "#1e40af", display: "flex",
                                                justifyContent: "center", padding: "0.25rem 0rem"
                                            }}
                                        >
                                            {person.application_status}
                                        </span>
                                    ) : person.application_status == "Task Pending" ? (
                                        <span
                                            className="inline-flex rounded-full px-2 text-xs font-semibold leading-5"
                                            style={{
                                                backgroundColor: "#f3e8ff", color: "#7c3aed", display: "flex",
                                                justifyContent: "center", padding: "0.25rem 0rem"
                                            }}
                                        >
                                            {person.application_status}
                                        </span>
                                    ) : person.application_status == "Task Submitted" ? (
                                        <span
                                            className="inline-flex rounded-full px-2 text-xs font-semibold leading-5"
                                            style={{
                                                backgroundColor: "#cffafe", color: "#155e75", display: "flex",
                                                justifyContent: "center", padding: "0.25rem 0rem"
                                            }}
                                        >
                                            {person.application_status}
                                        </span>
                                    ) : person.application_status == "Completed" ? (
                                        <span
                                            className="inline-flex rounded-full px-2 text-xs font-semibold leading-5"
                                            style={{
                                                backgroundColor: "#cffafe", color: "#1a8f49", display: "flex",
                                                justifyContent: "center", padding: "0.25rem 0rem"
                                            }}
                                        >
                                            {person.application_status}
                                        </span>
                                    ) : (
                                        <span className="inline-flex rounded-full px-2 text-xs font-semibold leading-5">
                                            {person.application_status}
                                        </span>
                                    )}
                                </td>
                                <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                    {/* <button

                                            className="text-blue-600 hover:text-indigo-900"
                                          >
                                            View Details
                                          </button> */}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                )}
            </table> </div>}

            {/* Pagination */}
            {isLoading ? null :
                <div className="flex items-center justify-between mt-7 bg-white px-4 py-3 sm:px-6  rounded-lg shadow">
                    <div className="flex flex-1 justify-between sm:hidden">
                        <button
                            onClick={() => {
                                handlePaginationClick("Previous");
                            }}
                            className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                        >
                            Previous
                        </button>
                        <button
                            onClick={() => {
                                handlePaginationClick("Next");
                            }}
                            className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                        >
                            Next
                        </button>
                    </div>
                    <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
                        <div>
                            <p className="text-sm text-gray-700">
                                Showing{" "}
                                <span className="font-medium">
                                    {totalRegEntries === 0 ? 0 :(pageNumber - 1) * pageSize + 1}
                                </span>{" "}
                                to <span className="font-medium">{Math.min(((pageNumber - 1) * pageSize) + pageSize, totalRegEntries)}</span> of{" "}
                                <span className="font-medium">{totalRegEntries}</span> results
                            </p>
                        </div>
                        <div>
                            <nav
                                className="isolate inline-flex -space-x-px rounded-md shadow-sm"
                                aria-label="Pagination"
                            >
                                <button
                                    onClick={() => {
                                        handlePaginationClick("Previous");
                                    }}
                                    className="relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20"
                                >
                                    <span className="sr-only">Previous</span>
                                    <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
                                </button>
                                {/* Current: "z-10 bg-indigo-50 border-indigo-500 text-indigo-600", Default: "bg-white border-gray-300 text-gray-500 hover:bg-gray-50" */}
                                {pageNumbers?.map((number) => {
                                    return (
                                        <button
                                            key={number}
                                            className={
                                                pageNumber == number
                                                    ? "relative z-10 inline-flex items-center border border-purple-500 bg-purple-50 px-4 py-2 text-sm font-medium text-purple-600 focus:z-20"
                                                    : "relative hidden items-center border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20 md:inline-flex"
                                            }
                                            onClick={() => handleClick(number)}
                                        >
                                            {number}
                                        </button>
                                    );
                                })}

                                <button
                                    onClick={() => {
                                        handlePaginationClick("Next");
                                    }}
                                    className="relative inline-flex items-center rounded-r-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20"
                                >
                                    <span className="sr-only">Next</span>
                                    <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
                                </button>
                            </nav>
                        </div>
                    </div>

                </div>}

        </div >

    )
}

export default ScholarshipApplications;
